/**
 * Возвращает перечень элементов в дереве абонентом возможных для создания по роли
 * @param role
 * @returns array
 * */
export const getUserListByRole = (role: string) => {
  const house = { className: 'THomeUser', name: 'Здание' };
  const mc = {
    className: 'TManagementCompanyUser',
    name: 'Управляющая компания',
  };
  const flat = { id: 1, className: 'TFlatUser', name: 'Квартира' };
  const group = { id: 2, className: 'TEntranceUser', name: 'Подъезд' };
  const simpleUser = {
    className: 'TSimpleUser',
    name: 'Абонент (единый счет)',
  };
  const hostUser = { className: 'THostUser', name: 'Абонент (мульти счет)' };
  const account = { className: 'TAccountUser', name: 'Счёт' };

  const list: any = {
    root: undefined, // Корень - Абоненты
    TManagementCompanyUser: [house], // Управляющая компания
    THomeUser: [flat, group], // Здание
    TEntranceUser: [flat], // Группа
    TFlatUser: [simpleUser, hostUser], // Квартира
    THostUser: [account], // Абонент (мульти счет)
    TAccountUser: [], // Счет
    TSimpleUser: [], // Абонент (единый счет)
  };

  if (role === 'adm' || role === 'adm_mc') {
    list['root'] = [mc, house];
  }

  return list;
};

/**
 * Возвращает перечень пользователей возможных для создания по роли
 * @param role
 * @return array
 */
export const getOperatorListByRole = (role: string) => {
  const admin = { className: 'TSuperAdminOperator', name: 'Администратор' };
  const adminMc = {
    className: 'TLocalAdminOperator',
    name: 'Администратор УК',
  };
  const user = { className: 'TUserOperator', name: 'Пользователь' };

  if (role === 'adm') {
    return [admin, adminMc, user];
  } else if (role === 'adm_mc') {
    return [user];
  } else if (role === 'usr') {
    return [];
  }

  return [];
};
